import * as types from "../types/foodPageSidebarRef"

export const foodSidebarScrollToButtom = () => ({
  type: types.FOOD_SIDEBAR_SCROLL_TO_BUTTOM
})

export const AddFoodPageSidebarRef = (ref) => ({
  type: types.ADD_FOOD_PAGE_SIDEBAR_REF,
  ref
})